// removed by extract-text-webpack-plugin
module.exports = {"container":"_1k8y9cxdP29l8_xRbB349s"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/OwnSignedDocuments/styles.css
// module id = 2719
// module chunks = 0